import "./ExploreSites.css";
import { Grid } from "@mui/material";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { Suspense } from "react";
import { useLoaderData, defer, Await } from "react-router-dom";
import { getSites } from "src/apis/complex";
import ComplexList from "src/components/Complex/ComplexList";
import { useRoleContext } from 'src/hooks/use-alert';
import ErrorPage from "src/pages/ErrorPages/ErrorPage";


export default function ExploreComplexes() {
  const navigate = useNavigate();
  const { roles }=  useRoleContext();

  const { complexes } = useLoaderData();

  return (
    <div>
      {
        <div className="explore">
          <div className="started"><h2>Explore Sites</h2></div>
          <div className="homeContainerExplore">
            <Grid container>
              <Grid item lg={3} md={4} sm={6} xs={12} paddingTop={"5px"} paddingRight={"5px"}>
                <div className="newComplexView">
                  <ButtonPolicy
                  
                  onClick={() => {navigate("/dashboard/explore-complexes/new-complex");}}
                    variant="text"
                  >
                    <div className="addNew">
                      <div className="iconHolder">
                        <AddIcon />
                      </div>

                      <div className="newComplex">
                        <span>Add new Complex</span>
                      </div>
                    </div>
                  </ButtonPolicy>
                </div>
              </Grid>
              <Suspense
                fallback={
                  <p style={{ textAlign: "center", color: "#FFF" }}> 
                    Loading...
                  </p>
                }
              >
                
                <Await resolve={complexes } errorElement={<ErrorPage />}>
                  {(loadedComplexes) => (
                    <ComplexList complexes={loadedComplexes} />
                  )}
                </Await>
                
              </Suspense>
            </Grid>
          </div>
        </div>
      }
    </div>
  );
}

async function loadComplexes() {
  const response = await getSites();
  return response;
}

export function loader() {
  return defer({
    complexes: loadComplexes(),
  });
}

